<!--
 * @Author: QWX
 * @Description:对账结算详情页
 * @LastEditors: QWX
 * @LastEditTime: 2021-11-25 11:27:08
-->
<template>
  <zl-saas-container>
    <!-- 操作记录 -->
    <operRecord :id="$route.query.id" v-if="!$route.query.approval"/>
    <!-- 对账结算基本信息 -->
    <baseInfo :baseInfo="basicForm" class="m-b"/>
    <!-- 选择子订单 -->
    <subOrder :baseInfo="basicForm" class="m-b" fromPage="purchaser" />
    <!-- 付款信息汇总 -->
    <paymentInfo :baseInfo="basicForm" :paymentList='paymentList' :currencyColumns="currencyColumns" class="m-b"/>
    <!-- 申请付款记录 -->
    <payReocrd v-if="showPayReocrd" :currencyCH="basicForm.currencyCh" fromPage="settlement" :orderId="orderId" :title="`申请付款记录`"/>
    <!-- 审批插槽 -->
    <slot></slot>
    <template slot="footer">
      <slot name="footer"/>
    </template>
  </zl-saas-container>
</template>
<script>
import operRecord from '@/components/business/operRecord.vue'
import baseInfo from '@/components/reconciliationAndSettlement/detail/baseInfo'
import subOrder from '@/components/reconciliationAndSettlement/detail/subOrder'
import paymentInfo from '@/components/reconciliationAndSettlement/detail/paymentInfo'
import { getValue } from '@/lib/enum'
import dayjs from 'dayjs'
import { mapActions } from 'vuex'
import payReocrd from '@/components/order/detail/payReocrd.vue'
export default {
  name: 'reconciliationAndSettlementDetail',
  components: {
    payReocrd,
    baseInfo,
    subOrder,
    operRecord,
    paymentInfo
  },
  data: function() {
    return {
      getValue,
      dayjs,
      basicForm: {},
      // 付款列表
      paymentList: [],
      currencyColumns: [],
      showPayReocrd: false,
      orderId: ''
    }
  },
  created() {
    this.initData()
  },
  methods: {
    ...mapActions([
      'getListSubOrderByAccountId',
      'listPaymentByAccountId',
      'getAccountDetail'
    ]),
    /**
     * @description: 初始数据
     */
    async initData() {
      this.listPaymentByAccountId({ accountId: this.$route.query.id }).then(res => {
        const arr = []
        this.paymentList = res.map(item => {
          item.payMoney = JSON.parse(item.payMoney)
          for (const p of item.payMoney) {
            if (!arr.includes(p.currencyCh)) {
              arr.push(p.currencyCh)
            }
          }
          return item
        })
        this.currencyColumns = arr
      })

      await this.getAccountDetail({ accountId: this.$route.query.id }).then(res => {
        res.accountSubOrderDTO = res.accountSubOrderDTO || []
        this.basicForm = res || {}
      })
      this.getListSubOrderByAccountId({ accountId: this.$route.query.id, view: true }).then(res => {
        this.basicForm.accountSubOrderDTO = res || []
        this.showPayReocrd = true
        if (res && res.length > 0) {
          this.orderId = res[0].orderId
        }
      })
    }
  }
}
</script>

<style lang="scss" >
@import '@/assets/css/reconciliationAndSettlement.scss';
</style>
<style lang="scss" scoped>
</style>
